const canUpgradeToCanadianDC = props =>
  !props.allowDirectCheckoutAndPaypal &&
    props.initiallySelectedPaymentMethod === 'paypal' &&
    props.directCheckoutProfileProps.profileAttributes.countryCode === 'CA';

const canUpgradeToEuropeanDC = props =>
  props.paymentSelection === 'PAYPAL_WITH_EU_DC_UPGRADE';

const shouldShowDCUpgradeHeading = props =>
  canUpgradeToCanadianDC(props) ||
    canUpgradeToEuropeanDC(props);

const canChangeShopCurrency = (paymentSelection, selectedPaymentMethod) =>
  paymentSelection === 'INTERNAL_DC_OR_PAYPAL' ||
    selectedPaymentMethod === 'paypal';

module.exports = {
  canChangeShopCurrency,
  shouldShowDCUpgradeHeading,
};



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/shop_policies/payment_method_utils.js